import type { DiscoveredRouteModule } from '@/router/generator/types';

const AuthHandoffView = () => import('@/views/auth/AuthHandoffView.vue');
export const NAME_AUTH_HANDOFF = 'AuthHandoff';
export const PATH_AUTH_HANDOFF = '/auth/handoff';

export const route: DiscoveredRouteModule = {
  id: 'root.auth.handoff',
  scope: 'root',
  name: NAME_AUTH_HANDOFF,
  path: PATH_AUTH_HANDOFF,
  component: AuthHandoffView,
  meta: {
    requiresAuth: false,
    skipProjectCheck: true,
    skipPermissionCheck: true,
    skipLoading: true
  }
};

